var noop = () => {};
export var debugConsole = debug => debug ? console : {
  error: noop,
  log: noop,
  info: noop,
  warn: noop,
  debug: noop
};